import axios from "axios";

export default {
    getOutlets() {
        return axios.get(`/point_ventes`);
    },
    postOutlet(obj) {
        return axios.post(`/point_ventes`, obj);
    },
    putOutlet(id, obj) {
        return axios.put(`/point_ventes/${id}`, obj);
    },
    deleteOutlet(id) {
        return axios.delete(`/point_ventes/${id}`);
    },

};
